<template>
    <div v-if="hasAccess">
        <fieldset class="product-rating-stars d-flex justify-content-end flex-row-reverse"
                  :class="{ 'cmp_product_rating_editable': !readonly }">
              <span v-if="!hideAvg" class="fw-bold">
                  {{ currentRating }} / 5
              </span>

            <template v-for="(rating, index) in values" :key="index">
                <input type="radio" :id="'star' + rating + '_review_' + prefix + '_' + index"
                       :value="rating"
                       :checked="rating === currentRating"
                       @change="updateRate(rating)"
                       :disabled="readonly">
                <label :class="['star', Number.isInteger(rating) ? 'full' : 'half']"
                       :for="'star' + rating + '_review_' + prefix + '_' + index"
                       :style="readonly ? { cursor: 'default', pointerEvents: 'none' } : {}"></label>
            </template>
        </fieldset>
        <div v-if="showReviewLink">
            <button class="btn btn-link cmp_product_rating_value text-start p-0" style="margin-top: -4px;"
                    @click="handleReviewClick">
                {{$t('Customer Reviews')}} <template v-if="store.ratingInfo">({{ store.ratingInfo.count || 0 }})</template>
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useUserStore } from '~/stores/UserStore';
import { useProductPageStore } from '~/stores/ProductPageStore';
import api from '~/apis/products';
import {useAlertStore} from "~/stores/AlertStore";

const emits = defineEmits(['reviewClicked', 'valueClicked']);

const props = defineProps({
    showValueAvg: {
        type: Boolean,
        default: true
    },
    showReviewLink: {
        type: Boolean,
        default: false
    },
    hideAvg: {
        type: Boolean,
        default: false
    },
    readonly: {
        type: Boolean,
        default: false
    },
    value: {
        type: Number,
        default: 0
    },
    input: {
        type: Boolean,
        default: false
    },
    prefix: {
        type: String,
        required: true
    }
});

const values = [5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1, 0.5];
const store = useProductPageStore();
const userStore = useUserStore();
const hasAccess = true;

let currentRating = ref(Math.floor(props.value * 2) / 2);

watch(() => props.value, (newValue) => {
    currentRating.value = newValue;
});

const updateRate = (rating) => {
    if (props.readonly) {
        return;
    }
    emits('valueClicked', rating);

    if (props.input || !store.product || !userStore.isLoggedIn()) {
        return;
    }
    currentRating.value = rating;
    api.rate(store.product.id, currentRating.value);

    const alertStore = useAlertStore();
    let alertType;

    if (currentRating.value >= 4) {
        alertType = 'success_1';
    } else if (currentRating.value >= 2.5) {
        alertType = 'success_2';
    } else {
        alertType = 'success_3';
    }

    alertStore.success(`alerts.rating.${alertType}.title`, `alerts.rating.${alertType}.message`);
}

function handleReviewClick() {
    emits('reviewClicked');
}

</script>

<style>
.product-rating-stars {
    > label::before {
        font-size: 16px !important;
        padding-right: 8px !important;
    }
}
.product-rating-stars > .half:before {
    width: 8.3px !important;
}
.cmp_product_rating_value {
    font-size: 14px !important;
}
.star:not(.cmp_product_rating_editable) label:hover::before {
    transform: none !important;
    opacity: 1 !important;
}
</style>
